// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_QKUpH","points-wrap":"points-wrap_c-nXS","default-bg":"default-bg_hiikr","icon":"icon_hCMhY"};